var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsChartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 320,
    width: 48,
    height: 160,
    rx: 8,
    ry: 8,
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 224,
    width: 48,
    height: 256,
    rx: 8,
    ry: 8,
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 112,
    width: 48,
    height: 368,
    rx: 8,
    ry: 8,
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 32,
    width: 48,
    height: 448,
    rx: 8,
    ry: 8,
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsChartOutline);
export default __webpack_public_path__ + "static/media/stats-chart-outline.af57ee261ce751a9a31884260150d529.svg";
export { ForwardRef as ReactComponent };